var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    rx: 32.5,
    fill: "#34C759",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4787 25.6828L26.9675 20.332L28.0883 22.2663C29.7152 21.5432 31.5048 21.1455 33.4029 21.1455C40.6157 21.1455 46.4545 26.9844 46.4545 34.1971C46.4545 41.4098 40.6157 47.2487 33.4029 47.2487C26.1902 47.2487 20.3333 41.3917 20.3333 34.179C20.3333 33.709 20.3513 33.2571 20.4056 32.8052",
    stroke: "#34C759",
    strokeWidth: 1.54332,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3464 28.339L21.6529 28.4836L23.4787 25.6816",
    stroke: "#34C759",
    strokeWidth: 1.54332,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1359 28.25L24.3463 28.3404",
    stroke: "#34C759",
    strokeWidth: 1.54332,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4917 28.1777L26.1359 28.25",
    stroke: "#34C759",
    strokeWidth: 1.54332,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4917 28.1763L31.3783 27.9774L29.9321 25.4828C30.9987 25.067 32.1556 24.832 33.3848 24.832C38.5548 24.832 42.7487 29.0259 42.7487 34.1959C42.7487 39.3659 38.5548 43.5598 33.3848 43.5598C28.2148 43.5598 24.0209 39.3659 24.0209 34.1959C24.0209 33.7259 24.0571 33.274 24.1294 32.8221",
    stroke: "#34C759",
    strokeWidth: 1.54332,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7102 29.0625V34.5579L29.8237 38.9325",
    stroke: "#34C759",
    strokeWidth: 1.54332,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingGreen);
export default __webpack_public_path__ + "static/media/pricingGreen.d808581cf57d3d98065f32d94b6f36a7.svg";
export { ForwardRef as ReactComponent };